// extracted by mini-css-extract-plugin
module.exports = {"filtersBar":"select-filter-component_filtersBar__19S59","filterSelect":"select-filter-component_filterSelect__2slhe"};